// Module
var code = "<div id=\"preloader\" class=\"col-md-10 col-md-offset-1\"> <br/> <h2 data-bind=\"restext: 'PageNotAvailableTitle'\"></h2> <p data-bind=\"restext: 'PageNotAvailableText'\"></p> <p> <a data-bind=\"restext: 'ReturnToRequestList'\" href=\"#requests\"></a> </p> </div> ";
// Exports
export default code;